module.exports = __webpack_public_path__ + "img/icon-checkbook.a3211f8c.svg";